import React, { useCallback, useMemo } from "react";
import { Util } from "@xt/xtbase";
import { observer } from "mobx-react-lite";
import { useStore } from "@/models";
import store from "store";
import { buildMarketConfigMap, isAiselectEligibleSymbol } from "@/utils/aiSelectEligible";

import styles from "./index.module.scss";

const { getUrl } = Util;

/** 跳转 aiselect 详情时保留完整交易对（含 _cfd），仅做规范化 */
export function toAiselectDetailSymbol(marketName: string): string {
  return String(marketName || "").trim().toLowerCase();
}

/** @deprecated 使用 toAiselectDetailSymbol */
export function toAiselectSpotSymbol(marketName: string): string {
  return toAiselectDetailSymbol(marketName);
}

export interface AiSelectNavButtonProps {
  symbol: string;
  className?: string;
  "aria-label"?: string;
}

const AiSelectNavButton: React.FC<AiSelectNavButtonProps> = ({ symbol, className, "aria-label": ariaLabel }) => {
  const { market } = useStore();
  const tradeSymbols = store.market.symbols;
  const marketConfig = useMemo(
    () => buildMarketConfigMap(market.marketConfig, tradeSymbols),
    [market.marketConfig, tradeSymbols]
  );
  const reactId = React.useId().replace(/:/g, "");
  const gradId = `aiselect_grad_${reactId}`;

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      const detailSymbol = toAiselectDetailSymbol(symbol);
      if (!detailSymbol) return;
      window.location.href = getUrl(`/aiselect/detail/${detailSymbol}`);
    },
    [symbol]
  );

  if (!isAiselectEligibleSymbol(symbol, marketConfig)) return null;

  return (
    <button
      type="button"
      className={`${styles.btn} ${className || ""}`.trim()}
      onClick={handleClick}
      aria-label={ariaLabel || "AI Select"}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.0175 5.19323C8.13172 4.93843 8.49222 4.93478 8.61125 5.18737L10.5478 9.29674C10.5801 9.36532 10.6354 9.42066 10.704 9.45299L14.8134 11.3895C15.0657 11.5087 15.0622 11.8691 14.8075 11.9833L10.7099 13.8202C10.6375 13.8528 10.5797 13.911 10.5468 13.9833L8.65617 18.1415C8.54102 18.3948 8.1823 18.3978 8.0634 18.1464L6.12394 14.0321C6.09156 13.9636 6.03622 13.9081 5.96769 13.8758L1.85441 11.9374C1.60268 11.8187 1.60507 11.4599 1.85832 11.3446L6.0175 9.45397C6.08995 9.42103 6.14803 9.36253 6.18058 9.28991L8.0175 5.19323ZM14.7294 1.83776C14.831 1.61184 15.1508 1.60899 15.2568 1.83287L16.1445 3.71666C16.1732 3.77768 16.2231 3.82658 16.2841 3.85533L18.1679 4.74303C18.3921 4.84889 18.3884 5.16989 18.162 5.27135L16.29 6.11022C16.2254 6.13915 16.1727 6.19134 16.1435 6.25573L15.2763 8.16295C15.1739 8.38816 14.8554 8.39062 14.7499 8.16686L13.8603 6.27916C13.8315 6.21826 13.7825 6.16925 13.7216 6.14049L11.8339 5.25084C11.6101 5.14538 11.6126 4.82587 11.8378 4.7235L13.745 3.85631C13.8094 3.82704 13.8606 3.77532 13.8896 3.7108L14.7294 1.83776Z"
          fill={`url(#${gradId})`}
        />
        <defs>
          <linearGradient id={gradId} x1="3.74975" y1="15.8333" x2="17.0831" y2="3.33313" gradientUnits="userSpaceOnUse">
            <stop stopColor="#6BBCFF" />
            <stop offset="0.45" stopColor="#707AFF" />
            <stop offset="0.8" stopColor="#C5A3FF" />
            <stop offset="1" stopColor="#FFAC63" />
          </linearGradient>
        </defs>
      </svg>
    </button>
  );
};

export default observer(AiSelectNavButton);
